import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 灯控旧表旧接口
 **********************************************************************************/
export default {
	/**
	 * 查询情景列表
	 */
	getLightSceneTree: (success, failure) => {
		Axios.post('/lightOld/getLightSceneTree.do', {}, success, failure)
	},
	/**
	 * 保存情景
	 */
	saveScene: (id, name, serialnum, interval, success, failure) => {
		Axios.post('/lightOld/saveScene.do', {
			id,
			name,
			serialnum,
			interval,
		}, success, failure)
	},
	/**
	 * 创建每日执行的时控
	 */
	saveDayTimeControl: (id, name, serialnum, interval, dayTimeInfo, success, failure) => {
		Axios.post('/lightOld/saveTimeControl.do', {
			id,
			name,
			serialnum,
			interval,
			dayTimeInfo,
			timeControlType: 0
		}, success, failure)
	},
	/**
	 * 创建每周执行的时控
	 */
	saveWeekTimeControl: (id, name, serialnum, interval, isMonday, mondayInfo, isTuesday, tuesdayInfo, isWednesday,
		wedinesdayInfo, isThursday, thursdayInfo, isFriday, fridayInfo, isSaturday, saturdaysInfo, isSunday, sundayInfo,
		success, failure) => {
		Axios.post('/lightOld/saveTimeControl.do', {
			id,
			name,
			serialnum,
			interval,
			timeControlType: 1,
			isMonday,
			mondayInfo,
			isTuesday,
			tuesdayInfo,
			isWednesday,
			wedinesdayInfo,
			isThursday,
			thursdayInfo,
			isFriday,
			fridayInfo,
			isSaturday,
			saturdaysInfo,
			isSunday,
			sundayInfo
		}, success, failure)
	},
	/**
	 * 创建每月执行的时控
	 */
	saveMonthTimeControl: (id, name, serialnum, interval, monthTimeInfo, success, failure) => {
		Axios.post('/lightOld/saveTimeControl.do', {
			id,
			name,
			serialnum,
			interval,
			monthTimeInfo,
			timeControlType: 2
		}, success, failure)
	},
	/**
	 * 周期性时控
	 */
	saveIntervalTimeControl: (id, name, serialnum, interval, day, hour, minute, success, failure) => {
		Axios.post('/lightOld/saveTimeControl.do', {
			id,
			name,
			serialnum,
			interval,
			day,
			hour,
			minute,
			timeControlType: 3
		}, success, failure)
	},
	/**
	 * 一次性时控
	 */
	saveDisposableTimeControl: (id, name, serialnum, interval, disposableTimeInfo, success, failure) => {
		Axios.post('/lightOld/saveTimeControl.do', {
			id,
			name,
			serialnum,
			interval,
			disposableTimeInfo,
			timeControlType: 4
		}, success, failure)
	},
	/**
	 * 批量删除情景
	 */
	deleteScene: (sceneIds, success, failure) => {
		Axios.post('/lightOld/deleteScene.do', {
			sceneIds
		}, success, failure)
	},
	/**
	 * 批量为情景添加设备
	 */
	saveDevice: (sceneId, deviceNos, percents, success, failure) => {
		Axios.post('/lightOld/saveDevice.do', {
			sceneId,
			deviceNos,
			percents
		}, success, failure)
	},
	/**
	 * 批量删除情景下的设备
	 */
	deleteDevice: (sceneId, deviceIds, success, failure) => {
		Axios.post('/lightOld/deleteDevice.do', {
			sceneId,
			deviceIds,
		}, success, failure)
	},
	/**
	 * 执行情景
	 */
	openOrCloseScene: (sceneId, success, failure) => {
		Axios.post('/lightOld/openOrCloseScene.do', {
			sceneId,
		}, success, failure)
	},
	/**
	 * 遥控照明变量状态
	 */
	openOrCloseVariable: (variableName,variableState, success, failure) => {
		Axios.post('/lightOld/openOrCloseVariable.do', {
			variableName,
			variableState,
		}, success, failure)
	},
	/**
	 * 照明调光遥控
	 */
	lightSinglewrite: (variableName,variableNameValue,value, success, failure) => {
		Axios.post('/lightOld/lightSinglewrite.do', {
			variableName,
			variableNameValue,
			value,
		}, success, failure)
	},
	/**
	 * 查询指定变量在某个时间段的开关列表
	 */
	getLightingRangeList: (variableNames, beginTime, endTime, success, failure) => {
		Axios.post('/lightOld/getLightingRangeList.do', {
			variableNames,
			beginTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询指定变量在某个时间段的亮灯时长
	 */
	getLightingRangeTime: (variableNames, beginTime, endTime, success, failure) => {
		Axios.post('/lightOld/getLightingRangeTime.do', {
			variableNames,
			beginTime,
			endTime
		}, success, failure)
	},


}
